import { render } from "./ChangePasswordForm.vue?vue&type=template&id=43609f7c&scoped=true&ts=true"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=ts"

import "./ChangePasswordForm.vue?vue&type=style&index=0&id=43609f7c&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43609f7c"]])

export default __exports__